import $ from 'jquery';

export default class AssetModal {

    constructor() {

        if ($("#asset-modal").length == 0) {
            return
        }

        this.dataObject = {
            asset: {},
            canupdate: false,
            cantrash: false,
            candelete: false,
            callback: null,
            types: []
        };

        Vue.component('asset-modal', () => import('../components/AssetModal.vue'));

        this.vm = new Vue({
            el: "#asset-modal",
            data: this.dataObject,
            methods: {


            }
        });

        $("#asset-modal").on('hidden.bs.modal', () => {
            console.log(true);
            this.close();
        });

    }


    showAsset(id, callback=null) {
        $.ajax({
            data: {
                "op": "getAsset",
                "id" : id
            },
            success: (d, s) => {

                $("#asset-modal").modal("show");
                this.dataObject.asset = d.asset;
                this.dataObject.canupdate = d.canupdate;
                this.dataObject.candelete = d.candelete;
                this.dataObject.cantrash = d.cantrash;
                this.dataObject.types = d.types;
                this.dataObject.callback = callback;

                // window.location.hash = "#asset:" + id;
                history.replaceState("",document.title, window.location.pathname + "#asset:" + id);
            }
        })
    }

    close() {
        history.replaceState("",document.title, window.location.pathname);
        // var loc = window.location;
        // history.pushState("", document.title, loc.pathname + loc.search);

        // window.location.hash = "";
        this.vm.$emit("stopall");
        $("#asset-modal").modal("hide");
    }



}
